<template>
  <el-dialog
    title="新增服务订单"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="35%"
  >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="客户名称:" prop="customerId">
        <el-select
          v-model="data.customerId"
          placeholder="请选择客户"
          @change="customerChange"
          filterable
          clearable
          style="width:100%"
        >
          <el-option
            v-for="dict in customerList"
            :key="dict.id"
            :label="dict.customerName"
            :value="dict.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="交付订单:" prop="deliveryOrderId">
        <el-select v-model="data.deliveryOrderId" placeholder="请选择交付订单" clearable style="width:100%">
          <el-option
            v-for="dict in deliveryList"
            :key="dict.id" :label="dict.orderNum" :value="dict.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="服务类型:" prop="serviceType">
        <el-select v-model="data.serviceType" placeholder="请选择服务类型" clearable style="width:100%">
          <el-option
            v-for="dict in serviceTypeList"
            :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="服务方式:" prop="serviceWay">
        <el-select v-model="data.serviceWay" placeholder="请选择服务方式" clearable style="width:100%">
          <el-option
            v-for="dict in seviceWayOptions"
            :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="问题判定:" prop="problemJudgeList">
        <el-select v-model="data.problemJudgeList" placeholder="请选择问题判定" clearable style="width:100%" multiple>
          <el-option
            v-for="dict in problemJudgeOptions"
            :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="问题概况:" prop="problemDesc">
        <el-input v-model="data.problemDesc" :maxlength="500" placeholder="请输入问题概况" clearable />
      </el-form-item>
      <el-form-item label="问题图片:">
        <FileUpload v-model="data.problemPicList" accept="image/gif,image/jpg,image/jpeg,image/png" :limit="9" :readOnly="false" @on-change="handleFileChange"></FileUpload>
      </el-form-item>
      <el-form-item label="问题发生日期:" prop="problemHappenDate">
        <el-date-picker v-model="data.problemHappenDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="处理方式:" prop="dealWay">
        <el-input v-model="data.dealWay" :maxlength="100" placeholder="请输入处理方式" clearable />
      </el-form-item>
      <el-form-item label="经验总结:" prop="experienceSummary">
        <el-input v-model="data.experienceSummary" :maxlength="100" placeholder="请输入经验总结" clearable />
      </el-form-item>
      <el-form-item label="服务费用(元):" prop="serviceFee">
        <el-input v-model="data.serviceFee" type="number" :maxlength="100" placeholder="请输入服务费用" clearable />
      </el-form-item>
      <el-form-item label="负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
      <el-form-item label="项目区域:" prop="area">
        <el-cascader
          v-model="data.area"
          :options="areaOptions"
          :props="{ checkStrictly: true }"
          filterable
          clearable
          style="width:100%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="项目地址:" prop="address">
        <el-input
          v-model="data.address"
          :maxlength="64"
          placeholder="请输入详细地址"
          clearable
        />
      </el-form-item>
      <el-form-item label="污水类型:" prop="sewageType">
        <el-select v-model="data.sewageType" placeholder="请选择污水类型" clearable style="width:100%">
          <el-option
            v-for="dict in sewageTypeOptions"
            :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日处理量:" prop="dailyProcessCapacity">
        <el-input
          v-model="data.dailyProcessCapacity"
          :maxlength="100"
          placeholder="请输入日处理量"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  listSimpleAll
} from "@/api/crm/customer";
import FileUpload from "@/views/crm/components/fileUpload";
import UserSelect from "@/views/crm/components/userSelect";
import { amountFormat, transferCascaderOptionsForProvince } from '@/utils/index'
import { createService, listDeliveryByPage } from "@/api/crm/order";
import {listAllLevelArea} from '@/api/crm/area'
import { mapState } from "vuex";

export default {
  name: "AddCustomerDialog",
  props: {},
  data() {
    return {
      visible: false,
      customerList: [],
      deliveryList: [],
      areaOptions: [], // 地址
      seviceWayOptions: [], // 服务方式
      sewageTypeOptions: [], // 污水类型
      problemJudgeOptions: [],
      serviceTypeList: [{ // 服务类型
        dictLabel: '主动',
        dictValue: '1'
      },{
        dictLabel: '被动',
        dictValue: '2'
      }],
      data: {
        customerId: null,
        deliveryOrderId: null,
        serviceType: null,
        serviceWay: null,
        problemJudgeList: [],
        problemPicList: [],
        problemHappenDate: null,
        problemDesc: null,
        dealWay: null,
        experienceSummary: null,
        area: [],
        address: null,
        managerId: null,
        serviceFee: null,
        sewageType: null,
        dailyProcessCapacity: null
      },
      rules: {
        customerId: [
          { required: true, message: "请选择客户", trigger: "change" }
        ],
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        serviceWay: [
          { required: true, message: "请选择服务方式", trigger: "change" }
        ],
        problemJudgeList: [
          { required: true, message: "请选择问题判定", trigger: "change" }
        ],
        problemDesc: [
          { required: true, message: "请输入问题概况", trigger: "change" }
        ],
        problemHappenDate: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        serviceFee: [
          { required: true, message: "请输入服务费用", trigger: "change" }
        ],
        area: [
          { required: true, message: "请选择项目区域", trigger: "change" }
        ],
        address: [
          { required: true, message: "请输入项目地址", trigger: "change" }
        ],
        sewageType: [
          { required: true, message: "请选择污水类型", trigger: "change" }
        ],
        dailyProcessCapacity: [
          { required: true, message: "请输入日处理量", trigger: "change" }
        ],
        managerId: [
          { required: true, message: "请选择负责人", trigger: "change" }
        ],
      },

    };
  },
  created() {
    listSimpleAll().then(response => {
      this.customerList = response.data;
    });
    this.getDicts("service_order_service_way").then(response => {
      this.seviceWayOptions = response.data;
    });
    this.getDicts("problem_judge").then(response => {
      this.problemJudgeOptions = response.data;
    });
    this.getDicts("sewage_type").then(response => {
      this.sewageTypeOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    FileUpload,
    UserSelect
  },
  watch: {
    visible(val) {
      if (!val) {
        this.data.problemPicList = [];
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(customerId, deliveryOrderId) {
      this.data.managerId = this.currentUserId;
      if(customerId){
        this.data.deliveryOrderId = deliveryOrderId
        this.data.customerId = customerId
        listDeliveryByPage({ customerId: customerId }).then(response => {
          this.deliveryList = response.rows || [];
        });
      }
      this.visible = true;
    },
    customerChange(customerId) {
      this.deliveryList = [];
      this.data.deliveryOrderId = null;
      if (customerId) {
        listDeliveryByPage({ customerId: customerId }).then(response => {
          this.deliveryList = response.rows || [];
        });
      }
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          createService(this.data)
            .then(response => {
              this.$emit("success");
              this.visible = false;
              loading.close();
              this.msgSuccess("新增成功");
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    handleFileChange (fileObjs) {
      this.data.problemPicList = fileObjs;
    },
  }
};
</script>
